<template>
  <!-- <div id="backdropVue" class="backdropVue"></div> -->

  <div class="nav-container">
    <div class="interno-gral">
      <!-- BOTON HAMBURGUESA MOBILE -->
      <div class="logos">
        <img
          src="./../../assets/images/menu.svg"
          style="width: 28px; height: 20px"
          id="mobile"
          @click="setMenu"
        />
        <div
          class="menu animate__animated"
          :class="menu ? 'animate__fadeInDown' : 'animate__fadeOutUp'"
          v-if="menu"
        >
          <div class="noti-scroll">
            <div class="item-menu" @click="setMenu">
              <router-link to="/home" class="link">
                <img src="./../../assets/images/LuqueInicio.svg" alt="" />

                <h2 class="h2-hero">Inicio</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>
            <div class="item-menu" @click="setMenu">
              <router-link to="/micuenta" class="link">
                <img src="./../../assets/images/LuqueDatos.svg" alt="" />

                <h2 class="h2-hero">Tus Datos</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>
            <div class="item-menu" @click="setMenu">
              <router-link to="/turnos" class="link">
                <img src="./../../assets/images/LuqueTurnos.svg" alt="" />
                <h2 class="h2-hero">Turnos</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>

            <div class="item-menu" @click="setMenu">
              <router-link to="/tramites" class="link">
                <img src="./../../assets/images/LuqueTramites.svg" alt="" />

                <h2 class="h2-hero">Trámites</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>
            <div class="item-menu" @click="setMenu">
              <router-link to="/documentos" class="link">
                <img src="./../../assets/images/LuqueDocumentos.svg" alt="" />

                <h2 class="h2-hero">Documentos</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>
            <div class="item-menu" @click="setMenu">
              <router-link to="/notificaciones" class="link">
                <img
                  src="./../../assets/images/LuqueNotificaciones.svg"
                  alt=""
                />

                <h2 class="h2-hero">Notificaciones</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>
            <div
              class="item-menu"
              @click="setMenu"
              v-if="!$store.state.representative"
            >
              <router-link to="/representaciones" class="link">
                <img
                  src="./../../assets/images/LuqueRepresentaciones.svg"
                  alt=""
                />

                <h2 class="h2-hero">Representaciones</h2>
              </router-link>
              <div class="linea-menu"></div>
            </div>

            <div
              class="item-menu"
              @click="off"
              style="border: none; border-radius: 0px 0px 0.5rem 0.5rem"
            >
              <div class="link">
                <img src="./../../assets/images/LuqueOffVerde.svg" alt="" />

                <h2 class="h2-hero">Cerrar sesión</h2>
              </div>
            </div>
          </div>
        </div>
        <router-link :to="`/home`">
          <img
            src="./../../assets/images/LuqueLogoBlanco.svg"
            alt="imagen"
            class="logo"
            @click="((menu = false), (notiMobile = false))"
          />
        </router-link>
      </div>

      <div class="usuario">
        <div class="circuloAvatar">
          <div class="interno">
            <img src="./../../assets/images/LuqueMuniAgente.svg" alt="imagen" />
          </div>
        </div>
        <div v-if="this.$store.state.user">
          <div id="saludo" v-if="!this.$store.state.representative">
            <P class="h1-default salu">
              ¡Hola
              {{ $store.state.user?.firstname }}!
            </P>
            <router-link :to="`/micuenta`">
              <p class="p-small salu">Ver tu perfil</p>
            </router-link>
          </div>
          <div v-else>
            <P class="p-botones">
              ¡Hola
              {{ $store.state.representative?.firstname }}!
            </P>
            <p class="p-small" style="display: flex">
              En representación de:

              {{ this.$store.state.user?.firstname }}
              <router-link :to="`/micuenta`" style="margin-left: 2px">
                (Ver perfil)
              </router-link>
            </p>
          </div>
        </div>
      </div>
      <div class="ofidi-redes">
        <img src="./../../assets/images/LuqueOfidi.svg" alt="" class="ofidi" />
        <div class="redes">
          <ThemedIcon @click="toggleTheme" name="theme" />
          <div
            class="circulo"
            @click="toggleAudio"
            :class="{ muted: !isPlaying }"
          >
            <img
              src="./../../../public/img/LuqueGif.gif"
              alt=""
              style="width: 2.489vw; height: 5.308vh"
            />
          </div>
          <div class="noti-wrapper" @click="openPanel">
            <img
              src="./../../assets/images/LuqueNotificacionesAmarillo.svg"
              alt="notificaciones"
            />

            <transition name="badge">
              <span v-if="cantidadNoLeidas > 0" class="noti-badge">
                {{ cantidadNoLeidas }}
              </span>
            </transition>
          </div>

          <img
            src="./../../assets/images/LuqueOff.svg"
            alt=""
            @click="dialog = true"
          />
        </div>
      </div>
      <div class="redesMobile">
        <ThemedIcon @click="toggleTheme" name="theme" />
        <router-link :to="`/micuenta`">
          <div class="circuloAvatar">
            <div class="interno">
              <img
                src="./../../assets/images/LuqueMuniAgente.svg"
                alt="imagen"
              />
            </div>
          </div>
        </router-link>
        <img
          src="./../../assets/images/LuqueNotificacionesAmarillo.svg"
          class="notificacionesIcon"
          alt=""
          @click="setNotiMobile"
        />
      </div>
      <!-- MODAL DE NOTIFICACIONES MOBILE -->
      <div
        class="menu animate__animated animate__fadeInDown"
        v-if="notiMobile"
        style="display: flex; flex-direction: column; gap: var(--gap10)"
      >
        <div class="noti-scroll">
          <div
            v-for="(item, index) in this.notificaciones"
            :key="index"
            style="
              border-bottom: 0.235px solid var(--text-primary, #3e3e3e);
              padding: 2.003vh 2vw;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width: 100%;
              "
            >
              <h2 class="h2-hero text">{{ truncateText(item.subject) }}</h2>
              <p class="h2-hero text">
                {{ new Date(item.created_at).toLocaleDateString() }}
              </p>
            </div>
            <p class="p-base text" style="width: 75%">
              {{ truncateText(item.message, 140) }}
            </p>
          </div>
        </div>
        <div class="footerNoti">
          <router-link :to="`/notificaciones`">
            <BtnBComponent texto="Ver todas" @click="notiMobile = false" />
          </router-link>
        </div>
      </div>
    </div>
    <div class="mobile" v-if="this.$store.state.representative">
      <p class="p-default">
        En representación de:

        {{ this.$store.state.user?.firstname }}
        <router-link :to="`/micuenta`" style="margin-left: 2px">
          (Ver perfil)
        </router-link>
      </p>
    </div>
  </div>
  <!-- MODAL DE NOTIFICACIONES DESKTOP-->
  <div
    v-if="showNotificaciones"
    class="overlay animate__animated"
    :class="showAnim ? 'animate__fadeIn' : 'animate__fadeOut'"
    @animationend="handleAnimationEnd"
    @click.self="closePanel"
  >
    <div
      class="panel animate__animated"
      :class="showAnim ? 'animate__slideInRight' : 'animate__slideOutRight'"
    >
      <div class="offcanvas-header">
        <div
          style="
            display: flex;
            flex-direction: row;
            gap: 0.59vw;
            align-items: center;
          "
        >
          <img
            src="./../../assets/images/LuqueNotificacionesAmarillo.svg"
            alt="imagen"
            class="alerta"
          />

          <h2 class="h1-default nota">Notificaciones</h2>
        </div>

        <ThemedIcon class="close" @click="closePanel" name="close" />
      </div>
      <div class="body">
        <div
          v-for="(item, index) in this.notificaciones"
          :key="index"
          @click="marcarComoLeida(item)"
          class="notificacion"
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <h2 style="word-break: keep-all" class="h2-hero nota">
              {{ truncateText(item.subject, 50) }}
            </h2>
            <p class="p-base h2-hero nota">
              {{ new Date(item.created_at).toLocaleDateString() }}
            </p>
          </div>
          <p class="p-base nota" style="width: 100%">
            {{ truncateText(item.message, 45) }}
          </p>
          <p class="p-small nota" style="margin-top: var(--gap10) !important">
            {{ item.read ? "Leída" : "No leída" }}
          </p>
        </div>
      </div>
      <router-link
        to="/notificaciones"
        class="boton"
        @click="showNotificaciones = false"
      >
        <button id="verTodasButton" class="p-botones">Ver todas</button>
      </router-link>
    </div>
  </div>

  <!-- MODAL DE NOTIFICACIONES SIN LEER -->
  <transition name="modal-noti">
    <ModalContenedorComponent
      v-if="dialog2"
      :cerrar="closeDialog2"
      :center="true"
      :mostrarClose="false"
    >
      <ModalNotiSinLeerComponent :cerrar="closeDialog2" />
    </ModalContenedorComponent>
  </transition>

  <!-- MODAL CERRAR SESION -->
  <ModalContenedorComponent
    v-if="dialog"
    :cerrar="closeDialog"
    :center="center = true"
    :mostrarClose="false"
  >
    <ModalOffComponent :cerrar="closeDialog" />
  </ModalContenedorComponent>
</template>
<script>
import axios from "axios";
import setToken from "@/middlewares/setToken";
import setTokenRelations from "@/middlewares/setTokenRelations";
import dbService from "@/services/dbService";
import ModalContenedorComponent from "../Modales/ModalContenedorComponent.vue";
import ModalOffComponent from "../Modales/ModalOffComponent.vue";
import ModalNotiSinLeerComponent from "../Modales/ModalNotiSinLeerComponent.vue";
import BtnBComponent from "../Buttons/BtnBComponent.vue";
import cancion from "./../../assets/Musica/cancion.mp3";
import { BASE_URL } from "@/env";
import CommunicationsService from "@/services/office/communicationsService";
import { setNotificationRead } from "@/services/offiVecino/Notifications/NotificationsServis";
import { SocketOffice } from "@/services/sockets/officeSocket";
import ThemedIcon from "../Utils/ThemedIcon.vue";
import { toggleTheme as toggleThemeHelper } from "@/services/helpers/themeHelper";
export default {
  name: "NavTopVue",
  data() {
    return {
      dialog: false,
      showNotificaciones: false,
      showAnim: false,
      cantidadNoLeidas: 0,
      dialog2: false,
      visible: false,
      menu: false,
      ruta: this.$router.currentRoute.value.fullPath,
      notificaciones: null,
      permission: true,
      user: "",
      representante: "",
      tokenUser: "",
      refreshTokenUser: "",
      cidiCookie: "",
      modalSinLeer: false,
      audio: null,
      isPlaying: true,
      notiMobile: false,
    };
  },

  mounted() {
    const userId = this.$store.state.user?.id;
    if (!SocketOffice || !userId) return;

    SocketOffice.on(`communications:update:${userId}`, () => {
      this.getNotifications();
    });
  },

  beforeUnmount() {
    const userId = this.$store.state.user?.id;
    if (!SocketOffice || !userId) return;

    SocketOffice.off(`communications:update:${userId}`);
  },

  created() {
    this.modalSinLeer = localStorage.getItem("modalShown") || false;
    this.marginleft = (window.innerWidth - 315) / 2;
    this.role = this.$store.state.user?.role;
    this.getNotifications();
    this.setMusic();
  },

  methods: {
    openPanel() {
      this.showAnim = true;
      this.showNotificaciones = true;
    },
    closePanel() {
      this.showAnim = false;
    },
    handleAnimationEnd() {
      if (!this.showAnim) {
        this.showNotificaciones = false;
      }
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    truncatedMessage(message, num) {
      if (!message) return "";
      return this.truncateText(message, num);
    },
    setMenu() {
      this.notiMobile = false;
      this.menu = !this.menu;
    },
    setNotiMobile() {
      this.notiMobile = !this.notiMobile;
      this.menu = false;
    },
    closeDialog() {
      this.dialog = false;
    },
    closeDialog2() {
      this.dialog2 = false;
    },
    dispatchLogin() {
      this.$store.dispatch("mockLoginAction", this.user);
    },
    dispatchLoginPermission() {
      this.$store.dispatch("mockPaseAction");
    },
    dispatchRepresentante() {
      this.$store.dispatch("mockRepresentanteAction", this.representante);
    },
    toggleTheme() {
      toggleThemeHelper();
    },
    getMyProfile() {
      const apiClient = axios.create({
        baseURL: BASE_URL,
        withCredentials: false,
        headers: {
          "auth-header": this.tokenUser,
        },
      });
      apiClient
        .get("/oficina/user/profile")
        .then((response) => {
          // console.log(response.data, "datos de usuariodb, navtop");
          this.user = response.data.UserProfile.user;
          this.dispatchLogin();
          this.dispatchLoginPermission();
        })
        .catch((error) => {
          if (error.response.status === 500) {
            if (error.response.data.message === "Token de usuario expirado") {
              setToken();
              this.getMyProfile();
            }
            if (
              error.response.data.message === "Token de representante expirado"
            ) {
              setTokenRelations();
              this.getMyProfile();
            }
          }
        });
    },
    //METODO PARA BUSCAR LAS NOTIFICACIONES DEL USUARIO PARA MOSTRAR EN MODAL LATERAL DE NOTIFICACIONES.
    async getNotifications() {
      const response = await CommunicationsService.getMyCommunications();
      if (!response?.success) return;
      let totalComunicaciones = response.data.Communications;
      this.notificaciones = totalComunicaciones.slice(0, 4);

      this.cantidadNoLeidas = totalComunicaciones.filter((n) => !n.read).length;

      if (this.cantidadNoLeidas > 0 && this.modalSinLeer === false) {
        this.dialog2 = true;
        localStorage.setItem("modalShown", true);
      }
    },
    async marcarComoLeida(item) {
      try {
        // Evita llamar al backend si ya está leída
        if (item.read) return;

        const response = await setNotificationRead(item.id);
        if (response.status === 200) {
          // Actualiza el estado localmente sin recargar
          item.read = true;
        }
      } catch (error) {
        console.error("Error al marcar notificación como leída:", error);
      }
    },
    async marcarTodasComoLeidas() {
      for (const item of this.notificaciones) {
        if (!item.read) {
          await this.marcarComoLeida(item);
        }
      }
    },
    //METODO PARA BUSCAR LOS DATOS DEL REPRESENTANTE
    // getRepresentante(id) {
    //   const apiClient = axios.create({
    //     baseURL: BASE_URL,
    //     withCredentials: false,
    //     headers: {
    //       "auth-header": localStorage.getItem("token"),
    //       "access-user-header":
    //         "^Yh19S&^8$yl01&Fagyg8eLxrI8uxypiCpdUdRscjF!xKSSqq",
    //     },
    //   });
    //   apiClient
    //     .get("/oficina/users/" + id)
    //     .then((response) => {

    //       this.representante = response.data.User;

    //       this.dispatchRepresentante();
    //     })
    //     .catch((error) => {
    //       // console.log(error);
    //       if (error.response.status === 500) {
    //         if (error.response.data.message === "Token de usuario expirado") {
    //           setToken();
    //           this.getRepresentante(id);
    //         }
    //         if (
    //           error.response.data.message === "Token de representante expirado"
    //         ) {
    //           setTokenRelations();
    //           this.getRepresentante(id);
    //         }
    //       }
    //     });
    // },
    //METODO PARA LIMPIAR LE SESION, COOKIE Y LOCALSTORAGE

    dispatchCidi() {
      this.$store.dispatch("mockCidiAction", this.cidiCookie);
    },
    logCidi(cidi) {
      this.dispatchCidi();
      //SE ENVIA LA QUERY PARA OBTENER TODA LA INFO DEL USUARIO
      const apiClient = axios.create({
        baseURL: BASE_URL,
        withCredentials: false,
      });
      apiClient
        .post("/auth/cidi/login/" + cidi)

        .then((response) => {
          let token = response.data["Tokens"] || null;
          let tokenRepresetations =
            response.data["TokenRepresentations"] || null;

          if (token) {
            localStorage.setItem("token", token.authToken);
            localStorage.setItem("refreshToken", token.refreshToken);
          }
          if (tokenRepresetations) {
            localStorage.setItem("token", tokenRepresetations.authToken);
            localStorage.setItem(
              "refreshToken",
              tokenRepresetations.refreshToken,
            );

            //se buscan los datos del usuario al que representa
            let payload = dbService.getToken(tokenRepresetations.authToken);
            let idRepresentante = payload.representative;
            localStorage.setItem("idRepresentante", idRepresentante);
            this.getMyProfile();

            this.getRepresentante(idRepresentante);
          }
        })
        .catch(() => {
          // console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    off() {
      this.setMenu();
      this.dialog = true;
    },
    setMusic() {
      if (this.$store.state.width > 770 && cancion) {
        this.audio = new Audio(cancion);
        this.audio.loop = true;
        this.audio.volume = 1;
        this.isPlaying = false;
      }
    },
    toggleAudio() {
      if (!this.audio) return;

      if (this.isPlaying) {
        this.audio.pause();
      } else {
        this.audio.play().catch((err) => {
          console.warn("No se pudo reproducir el audio:", err);
        });
      }
      this.isPlaying = !this.isPlaying;
    },
  },
  components: {
    ModalContenedorComponent,
    ModalOffComponent,
    ModalNotiSinLeerComponent,
    BtnBComponent,
    ThemedIcon,
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
}
a {
  color: var(--text-primary);
  text-decoration: none;
}
.nav-container {
  height: 12.521vh;
  width: 100%;

  align-items: center;
  background: #fff;
  position: fixed;
  z-index: 2;
}
.interno-gral {
  height: 100%;
  width: 100%;
  background: var(--gray-gradient);
  display: flex;
  padding: 0 5.124vw;
  flex-direction: row;
  align-items: center;
}
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
}
.logo {
  width: 9.517vw;
  height: 6.678vh;
  transition:
    transform 0.25s ease,
    filter 0.25s ease;
}
.logo:hover {
  transform: scale(1.05);
  filter: brightness(1.15);
}

.logo:active {
  transform: scale(0.98);
}
#mobile {
  display: none;
}
.usuario {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-left: 11.552vw;
  width: 21.962vw;
  gap: 0.95vw;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  z-index: 2000;
}
.panel {
  width: 28vw;
  height: 100%;
  padding: 5.008vh 2.196vw;
  border-radius: 1rem 0 0 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

[data-theme="light"] .panel {
  background: linear-gradient(180deg, #9e9e9e 0%, #676768 100%);
}

[data-theme="dark"] .panel {
  background: var(--gray-version);
}

.overlay.animate__animated,
.panel.animate__animated {
  --animate-duration: 0.4s;
}

.circuloAvatar {
  width: 3.66vw;
  height: 8.347vh;
  border: 2px solid transparent;
  overflow: hidden;
  border-radius: 50%;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}

.usuario:hover .circuloAvatar {
  transform: scale(1.08);
  box-shadow: 0 0 0 2px rgba(0, 195, 168, 0.15);
}

.interno img {
  width: 100%;
  height: 100%;
}

.salu {
  color: var(--blanco);
}

#saludo {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.ofidi-redes {
  display: flex;
  width: 26.428vw;
  margin-left: 20.619vw;
  align-items: center;
}
.redes {
  display: flex;
  flex-direction: row;
  margin-left: 7.321vw;
  align-items: center;
  gap: 0.878vw;
  width: 9.956vw;
}

.ofidi {
  width: 9.151vw;
  height: 5.426vh;
  transition:
    transform 0.25s ease,
    filter 0.25s ease;
}

.ofidi:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.circulo {
  display: flex;
  border: 1px solid var(--color-success);
  border-radius: 50%;
  height: 6.177vh;
  width: 2.78vw;
  align-content: center;
  position: relative;
  align-items: center;
  justify-content: center;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}
.circulo.muted::after {
  content: "";
  position: absolute;

  left: 0px;
  width: 100%;
  height: 2px;
  background: linear-gradient(180deg, #ff9f9d 0%, #ff2745 48.56%);
  transform: rotate(-135deg);
  border-radius: 2px;
}

.circulo:hover {
  transform: scale(1.08);
  box-shadow: 0 0 0 4px rgba(0, 195, 168, 0.2);
}

.redes img {
  height: 100%;
  width: 2.78vw;
  cursor: pointer;
  transition:
    transform 0.2s ease,
    filter 0.2s ease;
}

.redes img:hover {
  transform: scale(1.12);
  filter: brightness(1.1);
}

.redes img:active {
  transform: scale(0.95);
}
.noti-wrapper {
  position: relative;
  cursor: pointer;
}

.noti-wrapper img {
  width: 2.78vw;
  height: auto;
}

.noti-badge {
  font-size: 0.7rem;
  font-weight: 600;
  cursor: pointer;
  border: 0.18vw solid var(--bg-popup);
  background-color: red;
  color: var(--blanco);
  border-radius: 50%;
  width: 1.9vw;
  height: 1.9vw;
  position: absolute;
  top: -20%;
  right: -20%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-enter-active {
  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}
.badge-enter-from {
  transform: scale(0.5);
  opacity: 0;
}
.badge-enter-to {
  transform: scale(1);
  opacity: 1;
}

.badge-leave-active {
  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}
.badge-leave-from {
  transform: scale(1);
  opacity: 1;
}
.badge-leave-to {
  transform: scale(0);
  opacity: 0;
}

.offcanvas-end {
  border-radius: 1rem 0px 0px 1rem;
  background: linear-gradient(180deg, #9e9e9e 0%, #676768 100%);
  padding: var(--gap30) var(--gapH30);
  width: 28vw;
  height: 100vh;
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: 28.038vw;
  border-left: var(--bs-offcanvas-border-width) solid
    var(--bs-offcanvas-border-color);
}
.offcanvas-header {
  height: 6.461vh;
  padding: unset;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.body {
  flex: 1;
  overflow-y: auto;
  margin-top: 3.339vh;
  max-height: 70vh;
  scrollbar-width: none;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
}

.body > a:first-child {
  flex: 1;
  max-height: 70vh;
  overflow-y: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.body > a:first-child::-webkit-scrollbar {
  width: 6px;
}

.body > a:first-child::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 3px;
}

#verTodasButton {
  display: flex;
  width: 17.057vw;
  height: 8.347vh;
  padding: 1.669vh 1.098vw;
  justify-content: center;
  align-items: center;
  border-radius: 0.625rem;
  background: var(--color-success);
  color: var(--blanco);
}
button {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  background: none;
  box-shadow: none;
  transform: none;
  cursor: pointer;
}
.alerta {
  height: 5.676vh;
  width: 2.489vw;
}
.nota {
  color: var(--blanco);
}
.close {
  position: absolute;
  right: 35px;
  top: 6.012vh;
  cursor: pointer;
}

.notimobile {
  display: none;
}
.dropdown {
  display: none;
}

.notificacion {
  border-bottom: 0.25px solid #fff;
  margin-bottom: 10px;
  padding-bottom: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  justify-content: center;
  text-align: left;
}
.boton {
  position: absolute;
  bottom: 5.008vh;
  right: 5.124vw;
}

.modal-noti-enter-active {
  transition:
    opacity 0.25s ease,
    transform 0.25s ease;
}

.modal-noti-enter-from {
  opacity: 0;
  transform: scale(0.9) translateY(10px);
}

.modal-noti-enter-to {
  opacity: 0.3;
  transform: scale(1) translateY(0);
}

.modal-noti-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.modal-noti-leave-from {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.modal-noti-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(10px);
}

.burguer {
  display: none;
}
.redesMobile {
  display: none;
}
@media (max-width: 1300px) {
  .circulo {
    border: 2px solid transparent;
    background:
      linear-gradient(#808080, #808080) padding-box,
      var(--verdeGradient) border-box;
    border-radius: 50%;
    height: 4.74vh;
    width: 2.78vw;
    /* margin: auto ; */
    align-content: center;
    position: relative;
  }
}
@media (max-width: 990px) {
  .link {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
  .link h2 {
    color: var(--text-primary);
  }
  .link img {
    height: var(--gap20);
    width: var(--gapHM20);
  }
  .burguer {
    display: block;
    margin-left: 0px;
    font-size: calc(40px + (100vw - 990px) * 0.001);
    color: var(--blanco);
  }
  .menu {
    position: fixed;
    top: 12.521vh;
    left: 0;
    width: 100%;
    height: calc(100 * var(--vh) - 12.521vh);
    overflow-y: auto;
    background: var(--card-primary);
    border-radius: 0 0 0.5rem 0.5rem;
    padding: 0 3vw;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
  }
  .noti-scroll {
    flex: 1;
    overflow-y: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .text {
    color: var(--text-primary);
  }
  .item-menu {
    padding: var(--gap25) var(--gapHM15);
    border-bottom: 1px solid var(--text-primary);
  }
  .footerNoti {
    padding: var(--gap25);
    text-align: center;
  }
  .logos {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    align-content: center;
    justify-content: left;
    /* padding-left: 3.44vw; */
  }
  .circuloAvatar {
    width: 40px;
    height: 40px;
    border: 2px solid transparent;
    /* overflow: hidden; */
    /* border-radius: 50%; */
  }
  .notificacionesIcon {
    width: 40px;
    height: 40px;
  }
  .logo {
    width: 150px;
  }
  #mobile {
    display: block;
  }
  .redes {
    display: none;
  }
  .redesMobile {
    display: block;
    display: flex;

    gap: 15px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .ofidi {
    display: none;
  }
  .usuario {
    display: none;
  }
}
@media (max-width: 770px) {
  .redes {
    display: none;
  }
  .nav-container {
    height: 75px;
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 2;
  }
  .interno-gral {
    width: 100%;
    padding: 0px var(--gapHM15);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .logos {
    display: flex;
    flex-direction: row;
    gap: var(--gapHM15);
    align-content: center;
    justify-content: left;
    align-items: flex-end;
    /* padding-left: 3.44vw; */
  }
  /* .logos img {
    width: 28px;
    height: 20px;
  } */
  .redesMobile {
    display: block;
    display: flex;

    gap: 15px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .redesMobile img {
    width: 52px;
    height: 53%;
  }
  .circuloAvatar {
    width: 100%;
    height: 100%;
    border: unset;
    overflow: hidden;
    border-radius: unset;
    background: unset;
  }
  .usuario {
    display: none;
  }
  .logo {
    width: 27.083vw;
    height: 50%;
    max-width: 130px;
  }
  .ofidi {
    display: none;
  }
  .burguer {
    font-size: calc(30px + (100vw - 770px) * 0.001);
  }
  .interno img {
    width: 100%;
    height: 100%;
  }
  .menu {
    position: fixed;
    top: 12.521vh;
    left: 0;
    width: 100%;
    height: calc(100 * var(--vh) - 12.521vh);
    overflow-y: auto;
    border-radius: 0 0 0.5rem 0.5rem;
    padding: 0 3vw;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
  }
  .item-menu {
    padding: var(--gap25) var(--gapHM15);
    border-bottom: 1px solid var(--text-primary);
  }
  .footerNoti {
    padding: var(--gap25);
    text-align: center;
  }
  .ofidi-redes {
    display: none;
  }
  .mobile {
    display: block;
    background: var(--verdeGradient);
    position: absolute;
    bottom: -22px;
    width: 100%;
    height: 22px;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    align-content: center;
  }
  .mobile p {
    color: var(--text-primary);
    text-align: center;
  }
  .noti-scroll {
    flex: 1;
    overflow-y: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
  }
  .footerNoti {
    position: sticky;
    bottom: 0;
    background: var(--card-primary);
    text-align: center;
    z-index: 5;
  }
}

@media (max-width: 460px) {
  .interno-gral {
    width: 100%;
    padding: 0px var(--gapHM15);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .logos {
    width: 153.45px;
  }

  .logo {
    width: 122px;
    height: 50%;
  }

  .item-menu {
    padding: 1.669vh 2vw;
    border-bottom: 1px solid var(--text-primary);
    display: flex;
    align-items: center;
  }

  .menu {
    position: fixed;
    top: 75px;
    left: 0;
    width: 100%;
    height: calc(100 * var(--vh) - 75px);
    overflow-y: auto;
    padding: 0 3vw;
    border-radius: 0 0 0.5rem 0.5rem;
    z-index: 9999;
    display: flex;
    flex-direction: column;
  }

  .noti-scroll {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .redesMobile {
    width: 155px;
    gap: var(--gapHM15);
  }

  .burguer {
    font-size: calc(30px + (100vw - 460px) * 0.001);
  }
  .link {
    height: 7vh;
  }
}
</style>
